import React from 'react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

export default function EmployeeKPIChart({ dataset }) {
  const chartData = React.useMemo(() => {
    if (!dataset) return [];
    const data = dataset?.labels?.map((label, index) => {
      const item = { period: label };
      if (dataset?.totalPaidHours?.length) {
        item['Actual Hours'] = dataset?.totalPaidHours[index] || 0; // renamed
      }
      if (dataset?.calculatedDailyHours?.length) {
        item['Allowed Hours'] = (dataset.calculatedDailyHours[index] || 0) / 10; // renamed
      }
      if (dataset?.activeEmployeeCount?.length) {
        item['Active Employee Count'] = dataset?.activeEmployeeCount[index] || 0;
      }
      return item;
    });
    return data;
  }, [dataset]);

  const hasData = chartData?.some(item =>
    (item['Actual Hours'] && item['Actual Hours'] > 0) ||
    (item['Allowed Hours'] && item['Allowed Hours'] > 0) ||
    (item['Active Employee Count'] && item['Active Employee Count'] > 0)
  );

  return (
    <div className="bg-white p-6">
      <div className="mb-4">
        <p className="text-2xl text-gray-800">Employee KPI Trends</p>
      </div>

      {hasData ? (
        <div style={{ width: '100%', height: 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
             <XAxis dataKey="period" 
                          
                           angle={-15} // Rotate labels if they overlap
                           textAnchor="end" // Anchor rotation to the end
                           interval="preserveStartEnd" // Helps with tick spacing
                           tick={{ fontSize: 12 }} // Smaller font for X-axis ticks
                           label={{ value: "", offset: 10, fontSize: 12, fill: "#555" }} />
                           <YAxis label={{ value: 'Hours', angle: -90, position: 'insideLeft' }} />
                           {/* <Tooltip content={<CustomTooltip />} /> */}
              <YAxis label={{ value: 'KPI Values', angle: -90, position: 'insideLeft' }} />
              <Tooltip
                formatter={(value, name) => {
                  if (name === 'Allowed Hours') {
                    return [`${(value * 10).toFixed(2)} hrs`, 'Allowed Hours'];
                  }
                  if (name === 'Active Employee Count') {
                    return [`${value} employees`, 'Active Employee Count'];
                  }
                  return [`${value} hrs`, name];
                }}
              />
              <Legend verticalAlign="top" height={36} />

              {/* Bars */}
              {dataset.totalPaidHours?.length > 0 && (
                <Bar dataKey="Actual Hours" name="Actual Hours" fill="#CA585C" barSize={30} />
              )}
              {dataset.calculatedDailyHours?.length > 0 && (
                <Bar dataKey="Allowed Hours" name="Allowed Hours" fill="#9369A9" barSize={30} />
              )}

              {/* Line for Active Employee Count */}
              {dataset.activeEmployeeCount?.length > 0 && (
                <Line
                  type="monotone"
                  dataKey="Active Employee Count"
                  name="Active Employee Count"
                  stroke="#4CAF50"
                  strokeWidth={5}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                />
              )}
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="flex items-center justify-center h-96 text-gray-400 text-lg">
          No employee KPI data available.
        </div>
      )}
    </div>
  );
}
